import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";

export const findingsText1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 0 },
    spacing: { line: 276, before: 50, after: 400 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The following table gives of overview of the findings and their status by the end of our security audit process. ",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})
